export const environment = {
    services: {
        Identity: 'https://constanciasapidesa.sunedu.gob.pe/api/',
        IpService: 'https://api.ipify.org?format=json',
        Saip: 'https://saipapi.sunedu.gob.pe/api/',
    },
    google: {
        ClientId: "820854904139-ioibnesds3l4mipmilue615e76dl5kgv.apps.googleusercontent.com",
    },
    "bienvenidaUrl":"http://localhost:4200/#/home",
    "returnUrl":"http://localhost:4200/#/auth/verification",
    keyCaptcha: "6LflqMcrAAAAAKHSWoNM46s5wKAIGh2leTfz5I6p",
    production: true,
    development: false,
    enableBaseServiceLogs: true,
    encryptation: {
        enabled: true,
        key: '484060556f8744ab799c69961bc5a6c190f22097',
        excluded: [],
    },
    timeoutminuser: 15,
    gaMeasurementId: 'G-YT037D1755'
};
